import {IndustryGroup} from '../../domain/industry.domain';

export type SecondaryIndustrySelectionValue = IndustryGroup | null;
